import { render, staticRenderFns } from "./BtnSelecionarItemRequisicao.vue?vue&type=template&id=0c52c81d&"
import script from "./BtnSelecionarItemRequisicao.vue?vue&type=script&lang=js&"
export * from "./BtnSelecionarItemRequisicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports